// Browser print-to-PDF for the glossary. Opens a hidden window with a
// print-optimized layout and triggers window.print(). Matches the
// Finance tax-receipt pattern (zero new deps).

function escapeHtml(s) {
  return String(s == null ? "" : s)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

export function openGlossaryPrint({ entries, lastUpdatedAt, lastUpdatedByName }) {
  const safe = (entries || []).slice().sort((a, b) =>
    (a.french || "").localeCompare(b.french || "", "fr", { sensitivity: "base" }),
  );
  const stamp = lastUpdatedAt ? new Date(lastUpdatedAt).toLocaleDateString(undefined, { year: "numeric", month: "long", day: "numeric" }) : "—";

  const rows = safe.map(e => `
    <tr>
      <td class="col-fr">${escapeHtml(e.french)}</td>
      <td class="col-en">${escapeHtml(e.english)}</td>
      <td class="col-cat">${escapeHtml(e.category || "")}</td>
      <td class="col-notes">${escapeHtml(e.notes || "")}</td>
    </tr>
  `).join("");

  const html = `<!doctype html>
<html lang="en">
<head>
  <meta charset="utf-8" />
  <title>Kingdom of God Centre — Translation Glossary</title>
  <style>
    @page { size: A4; margin: 18mm 14mm 20mm; }
    * { box-sizing: border-box; }
    body { font-family: 'Georgia', 'Times New Roman', serif; color: #111; margin: 0; }
    header { border-bottom: 2px solid #0a2540; padding-bottom: 10px; margin-bottom: 18px; }
    h1 { font-size: 20pt; margin: 0 0 4px 0; font-family: 'Georgia', serif; color: #0a2540; letter-spacing: 0.5px; }
    .subtitle { font-size: 10pt; color: #555; }
    table { width: 100%; border-collapse: collapse; font-size: 10pt; }
    thead th {
      background: #0a2540; color: #fff;
      padding: 8px 10px; text-align: left; font-weight: 700;
      letter-spacing: 0.4px; font-size: 9pt; text-transform: uppercase;
    }
    tbody td { padding: 8px 10px; border-bottom: 1px solid #d8d8d8; vertical-align: top; }
    tbody tr:nth-child(even) { background: #f6f8fa; }
    .col-fr { font-weight: 700; width: 22%; }
    .col-en { width: 22%; color: #0a2540; font-weight: 600; }
    .col-cat { width: 16%; font-size: 9pt; color: #555; }
    .col-notes { font-size: 9pt; color: #333; }
    footer { position: fixed; bottom: 8mm; left: 0; right: 0; font-size: 8pt; color: #666; text-align: center; }
    .empty { text-align: center; padding: 40px; font-style: italic; color: #777; }
    .print-btn-bar {
      padding: 14px 18px; background: #0a2540; color: #fff; display: flex; align-items: center; gap: 12px;
    }
    .print-btn-bar button {
      background: #D4AF37; color: #111; border: 0; padding: 8px 18px; border-radius: 6px;
      font-weight: 700; font-size: 12pt; cursor: pointer;
    }
    .print-btn-bar .hint { font-size: 10pt; opacity: 0.85; }
    @media print {
      .print-btn-bar { display: none; }
    }
  </style>
</head>
<body>
  <div class="print-btn-bar">
    <button onclick="window.print()">Print / Save as PDF</button>
    <span class="hint">Choose "Save as PDF" from your browser's print dialog to export.</span>
  </div>
  <div style="padding: 14mm 10mm 20mm;">
    <header>
      <h1>Kingdom of God Centre — Translation Glossary</h1>
      <div class="subtitle">Last updated ${escapeHtml(stamp)}${lastUpdatedByName ? " · by " + escapeHtml(lastUpdatedByName) : ""} · ${safe.length} entries</div>
    </header>
    ${safe.length === 0 ? '<div class="empty">No glossary entries yet.</div>' : `
    <table>
      <thead>
        <tr>
          <th>French</th>
          <th>English</th>
          <th>Category</th>
          <th>Notes</th>
        </tr>
      </thead>
      <tbody>
        ${rows}
      </tbody>
    </table>
    `}
  </div>
  <footer>Generated by Kingdom Connect · ${new Date().toLocaleDateString()}</footer>
  <script>setTimeout(function(){ try { window.focus(); } catch(e){} }, 150);</script>
</body>
</html>`;

  const w = window.open("", "_blank");
  if (!w) {
    alert("Pop-ups must be allowed to print the glossary.");
    return;
  }
  w.document.open();
  w.document.write(html);
  w.document.close();
}
